import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const Feature = observer(() => {
  const navigate = useNavigate();

  const {
    authStore: { banners, top_coin, games, authenticated },
  } = useStores();

  return (
    <div className=" relative pb-[55px] pt-[70px]  lg:pb-[95px] lg:pt-[110px]    mx-auto max-full lg:max-w-[1140px] 2xl:max-w-[1320px] px-6 hero-animate">
      <div className="flex flex-col text-center max-w-[708px] mb-[50px] lg:mb-[75px] mx-auto">
        <h2 className="text-[#fff] text-[32px] mt-0 mb-2 leading-[1.2] font-[500]">
          Users around the world have a great experience with TOCOM
        </h2>
        <div className="text-[#fff]">
          TOCOM is a place of trust for millions of people. Our customer reviews
          overall and is rated just 4.5 out of 5 stars on Trustpilot. It is the
          right place for you.
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “I found EUREX very professional and trustworthy during my assets
            trading duration of 147 days. They are very honest and trusted.”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author1.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - Karen Lynn
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                Founder @ Company
              </span>
            </div>
          </div>
        </div>
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “100% Trusted. Very legit in digital world. So far I&amp;aposm
            satisfied with EUREX. I just wish this will continue at this way.”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author2.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - Software engineer
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                Subash Rajendran
              </span>
            </div>
          </div>
        </div>
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “The best place to start your trading path, thank you for support.
            Its a safe passive income strategy and will be multiply over time
            😍.”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author3.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - Milan Milenkovic
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                Businessman
              </span>
            </div>
          </div>
        </div>
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “Best digital scam investigator. It took less than 24h and gave all
            the details about the scammer and guided me. My heartfull thanks 💗
            ”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author4.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - Francois Malan
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                UI/UX Designer
              </span>
            </div>
          </div>
        </div>
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “Trustable ☺️ Best way to earn passive income. Everything was well
            explained and it was easy to follow their clear. Very legit in
            digital world.”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author5.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - UI/UX Designer
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                Manager @ Company
              </span>
            </div>
          </div>
        </div>
        <div className="p-10  flex flex-col justify-center rounded bg-[#26242c] group ">
          <div className="flex items-center  pl-8 mb-6 ">
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
            <div>
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.196 7.643h-8.038L10.683 0 8.194 7.643.156 7.628l6.501 4.73L4.168 20l6.5-4.73L17.17 20l-2.474-7.643 6.5-4.714z"
                  fill="#FFC947"
                />
                <path
                  d="M15.252 14.085l-.557-1.728-4.011 2.914 4.568-1.186z"
                  fill="#13111A"
                />
              </svg>
            </div>
          </div>
          <span className="text-[#fff]">
            “More than just satisfied.Trustable site and the owner is very
            friendly &amp; calm. And it’s great! The 0,5-1% daily on average is
            the target.”
          </span>
          <div className="flex gap-5 mt-6">
            <img
              src="https://api.demo92.apptestlive.com/assets/images/author6.webp"
              alt="avatar"
              className="rounded-full"
              height="60"
              width="60"
            />
            <div className="flex flex-col">
              <span className="text-[#fff] text-[20px] font-semibold">
                - Abdul Wadud
              </span>
              <span className="text-[#fff] text-[14px] opacity-70">
                WP Developer
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-14">
        <div className="relative group  w-fit flex items-center justify-center cursor-pointer ">
          <div className="absolute top-0 left-0 group-hover:top-[5px] group-hover:left-[5px] bg-[#fff] duration-300 ease-in-out w-full h-full rounded-[4px]" />
          <div className="relative text-[#000] bg-[#f7a600] px-[36px] py-4 font-bold  rounded-[4px]">
            View All Reviews
          </div>
        </div>
      </div>
    </div>
  );
});

export default Feature;
